import React from 'react'
import { Text } from '@nike/eds'

const ParseToken = ({ token, title }) => {
  return (
    <Text font='body-2'>
      <h4>{title}</h4>
      <pre>{JSON.stringify(token || {}, null, 2)}</pre>
    </Text>
  )
}
export default ParseToken
